import { render, staticRenderFns } from "./GenericEntitiesWidget.vue?vue&type=template&id=e97c48be"
import script from "./GenericEntitiesWidget.vue?vue&type=script&lang=js"
export * from "./GenericEntitiesWidget.vue?vue&type=script&lang=js"
import style0 from "./GenericEntitiesWidget.vue?vue&type=style&index=0&id=e97c48be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports